import { mergeClass } from "../../utils/common";

export default function NetworkImage({
  src,
  alt,
  className,
  fallback,
  loading,
}: {
  src?: string;
  alt?: string;
  className?: string;
  fallback?: boolean;
  loading?: "eager" | "lazy";
}) {
  if (!src && !fallback) return null;
  return (
    <img
      src={src ?? (fallback ? "https://placehold.co/80x80" : "")}
      alt={alt ?? ""}
      className={mergeClass("object-cover", className)}
      loading={loading}
    />
  );
}
